import type RootStore from 'stores/RootStore'

import TraversalStore from './TraversalStore'

const initializeTraversal = (rootStore: RootStore) =>
  new TraversalStore(rootStore)

export type { default as TraversalStore } from './TraversalStore'
export default initializeTraversal
